exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".worksBox[data-v-6c6ac205] {\n  padding-top: 0.104167rem;\n  padding-right: 5%;\n}\n.worksBox[data-v-6c6ac205] .avatar-uploader .el-upload {\n  width: 1.5625rem;\n  border: 0.005208rem dashed #ddd;\n}\n.worksBox[data-v-6c6ac205] .avatar {\n  width: 1.5625rem;\n}", ""]);

// exports
